/* eslint-disable no-case-declarations */
import { ColumnDirective, ColumnsDirective, CommandColumn, Edit, GridComponent, Inject, Sort, Toolbar } from '@syncfusion/ej2-react-grids';
import { NumericTextBoxComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { Count, HtmlEditor, QuickToolbar, RichTextEditorComponent, Toolbar as rteToolbar } from '@syncfusion/ej2-react-richtexteditor';
import { useEffect, useState } from 'react';
import { confirm } from "react-confirm-box";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { DeleteAPIData, LoadAPIData, SaveAPIData } from '../../helpers/DataHelper';
import { EditCommandTemplate, ConfirmDialogStyles, SearchGridToolbar, SimpleToolbarSettings } from '../../helpers/Global';
import { ShowToast } from '../../helpers/Toast';
import { fieldRequired } from '../../helpers/validation';
import { useNavigate } from "react-router-dom";

export default function EmailTemplates() {
  const navigate = useNavigate();
  const [editData, setEditData] = useState();
  const [editId, setEditId] = useState(0);

  const [type, setType] = useState(0);
  const [title, setTitle] = useState('');
  const [template, setTemplate] = useState('');
  //const [addedBy, setAddedBy] = useState(0);
  //const [dateAdded, setDateAdded] = useState(new Date());
  //const [modifiedBy, setModifiedBy] = useState(0);
  //const [dateModified, setDateModified] = useState(new Date());
  //const [status, setStatus] = useState(0);

  const [editModal, setEditModal] = useState(false);

  const toggle = () => setEditModal(!editModal);


  const commandClick = async (args) => {
    switch (args.commandColumn.type) {
      case 'Delete':
        //if (await confirm({confirmation: 'Are you sure you want to delete this item?'})) {
        if (await confirm("Are you sure you want to delete this item?", ConfirmDialogStyles)) {
          deleteItem(args.rowData.id);
        }
        break;
      default: //edit
        editItem(args.rowData.id);
        break;
    }
  }

  const loadData = async () => {
    setEditData(await LoadAPIData('/api/emailtemplates'));
  }

  const addItem = () => { editItem(0); }

  const editItem = (id) => {
    if (id > 0) {
      const data = editData.find((item) => { return item.id === id });
      console.log(data);
      setEditId(data.id);
      setType(data.type);
      setTitle(data.title);
      setTemplate(data.template);
    }
    else {
      //clear state fields
      setEditId(0);

      setType(0);
      setTitle('');
      setTemplate('');
    }
    setEditModal(true);
  };

  const validateForm = () => {
    var valid = true;
    //valid &= fieldRequired(type, 'tbTypeError', '* required');
    valid &= fieldRequired(title, 'tbTitleError', '* required');
    valid &= fieldRequired(template, 'tbTemplateError', '* required');

    return valid;
  }

  const saveItem = async (event) => {
    event.stopPropagation();

    if (validateForm()) {
      const data = { id: editId, type: type, title: title, template: template };

      const result = await SaveAPIData('/api/emailtemplates', data, (editId === 0 ? 'POST' : 'PUT'));
      if (result.success) {
        loadData();
        ShowToast('Email Templates', 'The email templates was successfully saved!', 'toast-success');
      }
      else {
        ShowToast('Email Templates', 'There was an error saving the email templates!', 'toast-danger');
      }
      toggle();
    }
  }

  const deleteItem = async (dataId) => {
    const result = await DeleteAPIData('/api/emailtemplates/' + dataId)
    if (result) {
      loadData();
      ShowToast('Email Templates', 'The email templates was successfully deleted!', 'toast-success');
    }
    else {
      ShowToast('Email Templates', 'There was an error deleting the email templates!', 'toast-danger');
    }
  }


  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-6 "><h1>Email Templates</h1></div>
        <div className="col-md-6 text-end align-self-center">
          <Button color="dark" outline size="sm" data-recordid="0" onClick={e => navigate(-1)}><i className="fas fa-chevron-left mr-2"></i> Back To Admin</Button>
          <Button className="ms-2 d-none" color="primary" size="sm" onClick={addItem}>Add New <i className="fas fa-plus-circle ms-2"></i></Button>
        </div>
      </div>

      <GridComponent dataSource={editData} allowSorting={true} toolbar={SearchGridToolbar} commandClick={commandClick} >
        <ColumnsDirective>
          <ColumnDirective field='Title' width='100' headerText="Title" />
          <ColumnDirective headerText='Actions' width='25' commands={EditCommandTemplate} />
        </ColumnsDirective>
        <Inject services={[Sort, Edit, CommandColumn, Toolbar]} />
      </GridComponent>

      <Modal isOpen={editModal} toggle={toggle} scrollable size="xl" backdrop="static">
        <ModalHeader toggle={toggle}>{editId === 0 ? "Add New" : "Edit"} Email Templates</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-9">
              <div className='mb-3 d-none'>
                <NumericTextBoxComponent id='tbType' name='tbType' placeholder='Type' floatLabelType='Auto' showClearButton={true} value={type} onChange={e => setType(e.value)} />
                <div id='tbTypeError' className='error-message' />
              </div>

              <div className='mb-3'>
                <TextBoxComponent id='tbTitle' name='tbTitle' placeholder='Title' type='text' maxLength='250' floatLabelType='Auto' showClearButton={true} value={title} onChange={e => setTitle(e.value)} />
                <div id='tbTitleError' className='error-message' />
              </div>

              <div className='mb-3'>
                <label htmlFor='tbTemplate'>Template</label>
                <RichTextEditorComponent id='tbTemplate' name='tbTemplate' placeholder='Template' toolbarSettings={SimpleToolbarSettings} showCharCount={true} value={template} change={e => setTemplate(e.value)} height="300px" >
                  <Inject services={[rteToolbar, HtmlEditor, QuickToolbar, Count]} />
                </RichTextEditorComponent>
                <div id='tbTemplateError' className='error-message' />
              </div>
            </div>
            <div className="col-md-3">
              <h5>Merge Fields</h5>
              <p><b>|firstname|</b> The users firstname.</p>
              <p><b>|lastname|</b> The users lastname.</p>
              <p><b>|email|</b> The users email address.</p>
              <p><b>|orderincldel|</b> The order details (including delivery)</p>
              <p><b>|orderexcldel|</b> The order details (excluding delivery)</p>
              <p><b>|ordernumber|</b> The order number</p>
              <p><b>|resetbutton|</b> Reset password button</p>
              <p><b>|resetlink|</b> Reset password link</p>
              <p><b>|site|</b> The site sending the order</p>
            </div>
          </div>

          


        </ModalBody>
        <ModalFooter>
          <Button color="dark" size="sm" onClick={toggle}>Cancel <i className="far fa-times-circle ms-2"></i></Button>
          <Button color="success" size="sm" onClick={saveItem}>Save <i className="far fa-check-circle ms-2"></i></Button>
        </ModalFooter>
      </Modal>

    </>
  );
}

